import {
    FETCH_SECTION_SELECTED_START,
    FETCH_SECTION_SELECTED_ERROR,
    FETCH_SECTION_SELECTED_SUCCESS,
} from '../actions/actionTypes'

const initialState = {
    selectedSection: {},
    loading: false,
    error: null,
}

export const selectedSectionReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SECTION_SELECTED_START:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case FETCH_SECTION_SELECTED_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                selectedSection: action.payload,
            }
        case FETCH_SECTION_SELECTED_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        default:
            return state
    }
}
